import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { SlidersHorizontal, LayoutGrid, List } from "lucide-react";
import { STATE_OPTS } from "./helpers";

const Sec = ({ title, children }) => (
  <div className="mb-3 last:mb-0">
    <div className="text-[11px] font-bold uppercase tracking-[.08em] text-muted-foreground mb-2">{title}</div>
    <div className="flex flex-wrap gap-1.5">{children}</div>
  </div>
);

const Chip = ({ on, count, onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`min-h-[34px] px-3 inline-flex items-center gap-1.5 rounded-full font-bold text-[13px] border transition-colors ${
      on ? "bg-brand text-white border-brand" : "border-border bg-card text-muted-foreground hover:text-foreground"}`}>
    {children}{count != null && <span className="opacity-60 tabular-nums">{count}</span>}
  </button>
);

// Filtr jedním panelem (§4.4). Počty se počítají z aktivní třídy bez ostatních filtrů.
export function FilterPanel({ open, onOpenChange, fstate, fcats, fsups, setFstate, toggleCat, toggleSup,
  clearAll, stateCounts, catOpts, supOpts, group, setGroup }) {
  const activeCount = (fstate ? 1 : 0) + fcats.length + fsups.length;
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <button type="button" data-testid="pasport-filter-trigger"
          className={`min-h-[38px] px-4 inline-flex items-center gap-2 rounded-full font-bold text-[14px] border transition-colors ${
            activeCount ? "bg-brand text-white border-brand" : "border-border bg-card text-foreground hover:bg-secondary"}`}>
          <SlidersHorizontal size={15} /> Filtr
          {activeCount > 0 && (
            <span className="bg-white text-brand h-5 min-w-5 px-1 rounded-full text-[12px] font-bold grid place-items-center tabular-nums">
              {activeCount}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" sideOffset={6}
        className="w-[340px] p-3.5 bg-card border border-border rounded-[14px] shadow-[0_16px_40px_rgba(0,0,0,0.16)]"
        data-testid="pasport-filter-panel">
        <Sec title="Zobrazit podle">
          <Chip on={group === "room"} onClick={() => setGroup("room")} testid="group-room"><LayoutGrid size={14} /> Místnosti</Chip>
          <Chip on={group === "cat"} onClick={() => setGroup("cat")} testid="group-cat"><List size={14} /> Kategorie</Chip>
        </Sec>
        <Sec title="Stav položky">
          {STATE_OPTS.map(([v, l]) => (
            <Chip key={v} on={fstate === v} count={stateCounts[v]} testid={`filter-state-${v}`}
              onClick={() => setFstate(fstate === v ? null : v)}>{l}</Chip>
          ))}
        </Sec>
        {catOpts.length > 0 && (
          <Sec title="Kategorie">
            {catOpts.map(([name, n]) => (
              <Chip key={name} on={fcats.includes(name)} count={n} testid={`filter-cat-${name}`}
                onClick={() => toggleCat(name)}>{name}</Chip>
            ))}
          </Sec>
        )}
        {supOpts.length > 0 && (
          <Sec title="Dodavatel">
            {supOpts.map(([name, n]) => (
              <Chip key={name} on={fsups.includes(name)} count={n} testid={`filter-sup-${name}`}
                onClick={() => toggleSup(name)}>{name}</Chip>
            ))}
          </Sec>
        )}
        <div className="flex items-center gap-3 pt-3 mt-1 border-t border-border">
          <Button variant="outline" onClick={clearAll} disabled={!activeCount} className="h-9 font-bold text-[13px]" data-testid="pasport-filter-clear">
            Zrušit vše
          </Button>
          <span className="text-[13px] text-muted-foreground flex-1">{activeCount ? `${activeCount} aktivní` : "Bez omezení"}</span>
          <Button onClick={() => onOpenChange(false)} className="h-9 font-bold text-[13px]" data-testid="pasport-filter-done">Hotovo</Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
